<div class="userManHolder app-container">
    <!-- Message Display -->
    <div id="errorMSG">
        <div
            *ngIf="displayMessage || displayErrMessage"
            [ngClass]="{
                errMessageerr: displayErrMessage,
                errMessage: displayMessage
            }"
        >
            {{ message }}
        </div>
        <div
            *ngIf="confirmResult"
            class="errMessage"
        >
            {{ confirmResultMessage }}
        </div>
    </div>

    <!-- Manage User Card -->
    <mat-card
        class="manage-user-card"
        *ngIf="addUser || editUser"
    >
        <div class="card-header">
            <h3 class="card-title">
                {{ editUser ? 'Edit User' : 'Add User' }}
            </h3>
        </div>
        <div class="card-content">
            <form
                class="user-form"
                [formGroup]="userForm"
            >
                <div class="form-fields">
                    <mat-form-field
                        class="example-full-width"
                        appearance="fill"
                    >
                        <mat-label>First Name</mat-label>
                        <input
                            matInput
                            formControlName="name"
                        />
                        <mat-error *ngIf="checkError('name', 'required')"
                            >First Name is required.</mat-error
                        >
                    </mat-form-field>

                    <mat-form-field
                        class="example-full-width"
                        appearance="fill"
                    >
                        <mat-label>Last Name</mat-label>
                        <input
                            matInput
                            formControlName="last_name"
                        />
                        <mat-error *ngIf="checkError('last_name', 'required')"
                            >Last Name is required.</mat-error
                        >
                    </mat-form-field>

                    <mat-form-field
                        class="example-full-width"
                        appearance="fill"
                    >
                        <mat-label>Username</mat-label>
                        <input
                            matInput
                            formControlName="username"
                            autocomplete="new-password"
                        />
                        <mat-error *ngIf="checkError('username', 'required')"
                            >Username is required.</mat-error
                        >
                    </mat-form-field>

                    <mat-form-field
                        class="example-full-width"
                        appearance="fill"
                    >
                        <mat-label>Password</mat-label>
                        <input
                            matInput
                            type="password"
                            formControlName="password"
                            autocomplete="new-password"
                        />
                        <mat-error *ngIf="checkError('password', 'required')"
                            >Password is required.</mat-error
                        >
                    </mat-form-field>

                    <mat-form-field
                        class="example-full-width"
                        appearance="fill"
                    >
                        <mat-label>Retype</mat-label>
                        <input
                            matInput
                            type="password"
                            formControlName="retyped_password"
                        />
                        <mat-error
                            *ngIf="checkError('retyped_password', 'required')"
                            >Retyped Password is required.</mat-error
                        >
                        <mat-error
                            *ngIf="
                                submitted &&
                                userForm.get('retyped_password').errors
                                    ?.retypedValidator
                            "
                            >Password and Retyped Password didn't match.
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-fields-row">
                    <mat-card
                        class="user-roles-card"
                        *ngIf="superAdmin"
                    >
                        <mat-card-content>
                            <label class="section-label">Role</label>
                            <section class="user-roles-section">
                                <mat-radio-group
                                    formControlName="userRole"
                                    class="user-roles-radio-group"
                                >
                                    <mat-radio-button
                                        class="user-roles-role"
                                        [value]="'admin'"
                                        >Admin</mat-radio-button
                                    >
                                    <mat-radio-button
                                        class="user-roles-role"
                                        [value]="'superAdmin'"
                                        >Super Admin</mat-radio-button
                                    >
                                </mat-radio-group>
                            </section>
                        </mat-card-content>
                    </mat-card>

                    <mat-card class="user-status-card">
                        <mat-card-content>
                            <label class="section-label">Status</label>
                            <section class="user-status-section">
                                <mat-checkbox
                                    formControlName="active"
                                    class="user-status-checkbox"
                                    >Active</mat-checkbox
                                >
                            </section>
                        </mat-card-content>
                    </mat-card>
                </div>

                <div class="form-actions">
                    <button
                        mat-flat-button
                        color="primary"
                        type="button"
                        (click)="onSubmit()"
                    >
                        <mat-icon>save</mat-icon>
                        Save
                    </button>
                    <button
                        mat-stroked-button
                        type="button"
                        (click)="cancel()"
                    >
                        <mat-icon>cancel</mat-icon>
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    </mat-card>

    <!-- Users Table -->
    <mat-card class="table-card">
        <div class="table-header">
            <h3 class="table-title">Users</h3>
            <div>
                <button
                    mat-flat-button
                    color="accent"
                    (click)="onAdd()"
                    type="button"
                    class="add-btn"
                    *ngIf="!editUser && !addUser"
                >
                    <mat-icon>add</mat-icon>
                    Add User
                </button>
                <button
                    mat-icon-button
                    (click)="refreshData()"
                    class="refresh-btn"
                    matTooltip="Refresh"
                >
                    <mat-icon>refresh</mat-icon>
                </button>
            </div>
        </div>

        <div class="mat-table-holder">
            <table
                class="user-table"
                mat-table
                [dataSource]="dataSource"
            >
                <!-- Position Column -->
                <ng-container matColumnDef="user_id">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        User ID
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                    >
                        {{ element.userId }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        First Name
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                    >
                        {{ element.name }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="last_name">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        Last Name
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                    >
                        {{ element.lastName }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="username">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        Username
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                    >
                        {{ element.username }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="admin">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        BO Admin
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                    >
                        <mat-icon
                            *ngIf="element.admin"
                            class="check"
                            >check</mat-icon
                        >
                        <mat-icon
                            *ngIf="!element.admin"
                            class="check"
                        >
                            remove
                        </mat-icon>
                    </td>
                </ng-container>

                <ng-container matColumnDef="superAdmin">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        BO Super Admin
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                    >
                        <mat-icon
                            *ngIf="element.superAdmin"
                            class="check"
                            >check</mat-icon
                        >
                        <mat-icon
                            *ngIf="!element.superAdmin"
                            class="check"
                        >
                            remove
                        </mat-icon>
                    </td>
                </ng-container>

                <ng-container matColumnDef="active">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >
                        Active
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                    >
                        <mat-icon
                            *ngIf="element.active"
                            class="check"
                        >
                            check
                        </mat-icon>
                        <mat-icon
                            *ngIf="!element.active"
                            class="check"
                        >
                            remove
                        </mat-icon>
                    </td>
                </ng-container>

                <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumns"
                ></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                    #row
                    [ngClass]="{ selectedRow: row.selected === true }"
                    (click)="onRowClick(row)"
                    class="clickable-row"
                ></tr>
            </table>
        </div>
    </mat-card>
</div>
